<ng-template #sharedCell let-row>
  @if (row?.accessListCounter > 1) {
    <span class="ui-icon-globe" aria-hidden="true"></span>
  }
</ng-template>

<div class="ui-tab w-100 h-100 flex-col gap-16">
  <div class="flex-row space-between-center">
    <div class="filters-wrapper">
      <ui-search
        [searchQuery]="search()"
        (onInput)="search.set($event)"
        [placeholder]="'PERSON_GROUPS.PLACEHOLDERS.SEARCH' | translate">
      </ui-search>
<!--      <ui-button-->
<!--        [text]="'PERSON_GROUPS.JOIN' | translate"-->
<!--        type="default"-->
<!--        [loading]="selectIsJoiningPersonGroup()"-->
<!--        [disabled]="selectIsJoiningPersonGroup()"-->
<!--        (click)="join()">-->
<!--      </ui-button>-->
      <ui-button
        [text]="'PERSON_GROUPS.CREATE' | translate"
        [loading]="selectIsCreatingPersonGroup()"
        [disabled]="selectIsCreatingPersonGroup()"
        (click)="create()">
      </ui-button>
    </div>
  </div>

  <div class="h-100 min-h-0">
    <div class="h-100 min-h-0 flex-col">
      <div class="h-100 min-h-0">
        @if (selectIsLoading()) {
          <div class="w-100 h-100">
            <ui-preloader [color]="loaderColor.blue"></ui-preloader>
          </div>
        } @else {
          @switch (viewState()) {
            @case (viewStates.HAS_CONTENT) {
              <ui-dataset-table
                [data]="filteredGroups()"
                [config]="tableConfig()"
                (rowAction)="onRowAction($event)">
              </ui-dataset-table>
            }
            @case (viewStates.NO_RESULTS) {
              <ui-no-data
                [imgSrc]="noResults.imgSrc"
                [title]="noResults.title | translate">
              </ui-no-data>
            }
            @case (viewStates.INITIAL_EMPTY) {
              <ui-no-data
                [imgSrc]="initialEmpty.imgSrc"
                [title]="initialEmpty.title | translate">
              </ui-no-data>
            }
          }
        }
      </div>
    </div>
  </div>
</div>
